import {GlobalVariables} from "../GlobalVariables";

export default class BlockWebinaires {

	constructor() {
		this.init();
	}

	init() {
		const blocks = document.querySelectorAll('.block-webinaires');

		blocks.forEach(block => {
			this.initBlock(block);
		});
	}

	initBlock(block) {
		const toggleBtn = block.querySelector('.webinar-card-load-more');
		if (!toggleBtn) return;

		const grid = block.querySelector('[data-webinar-grid]');
		if (!grid) return;

		const items = grid.querySelectorAll('.webinar-item');
		const initialDisplayCount = 2;
		let isExpanded = false;

		items.forEach((item, index) => {
			if (index >= initialDisplayCount) {
				item.style.display = 'none';
			}
		});

		const label = toggleBtn.querySelector('.label .pe-1');
		if (label) {
			label.textContent = 'Afficher plus';

			if (!toggleBtn.querySelector('svg')) {
				const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				svg.setAttribute('width', '17');
				svg.setAttribute('height', '9');
				svg.setAttribute('viewBox', '0 0 17 9');
				svg.setAttribute('fill', 'none');

				const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
				path.setAttribute('d', 'M15.75 0.75L8.25 8.25L0.75 0.75');
				path.setAttribute('stroke', 'currentColor');
				path.setAttribute('stroke-width', '1.5');
				path.setAttribute('stroke-linecap', 'round');
				path.setAttribute('stroke-linejoin', 'round');

				svg.appendChild(path);
				label.insertAdjacentElement('afterend', svg);
			}
		}

		toggleBtn.addEventListener('click', () => {
			isExpanded = !isExpanded;

			items.forEach((item, index) => {
				if (index >= initialDisplayCount) {
					item.style.display = isExpanded ? 'block' : 'none';
				}
			});

			if (label) {
				label.textContent = isExpanded ? 'Afficher moins' : 'Afficher plus';
			}

			const svg = toggleBtn.querySelector('svg');
			if (svg) {
				svg.style.transform = isExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
				svg.style.transition = 'transform 0.3s ease';
			}
		});
	}

}